import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'ticketStatus' })
export class TicketStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(ticketStatus: TicketStatus): string {
        switch (ticketStatus) {
            case TicketStatus.all:
                return this.translateService.instant('All');
            case TicketStatus.notCompleted:
                return this.translateService.instant('Not closed');
            case TicketStatus.open:
                return this.translateService.instant('Open');
            case TicketStatus.pending:
                return this.translateService.instant('Pending');
            case TicketStatus.completed:
                return this.translateService.instant('Closed');
            default:
                return this.translateService.instant('Unknown status');
        }
    }
}
